import {
  Component,
  Inject,
  Injector,
  forwardRef,
  ElementRef,
  OnInit,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { OTranslateService } from '../../services';

import { OSideMenuModule, OSideMenuComponent } from './o-side-menu.component';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_LOCALE_SIDE_MENU_ITEM = [
  // title [string]: menu item title. Default: no value.
  'title',

  // tooltip [string]: menu group tooltip. Default: 'title' value.
  'tooltip',

  // icon [string]: material icon. Default: no value.
  'icon',

  // locale [string]: language. For example: es
  'locale'
];


export class OLocaleSideMenuItemComponent implements OnInit {

  public static DEFAULT_INPUTS_O_LOCALE_SIDE_MENU_ITEM = DEFAULT_INPUTS_O_LOCALE_SIDE_MENU_ITEM;

  protected menu: OSideMenuComponent;
  protected translateService: OTranslateService;

  public title: string;
  public tooltip: string;
  public icon: string;
  public locale: string;

  constructor(
     menu: OSideMenuComponent,
    protected elRef: ElementRef,
    protected injector: Injector) {
    this.menu = menu;
    this.translateService = this.injector.get(OTranslateService);
  }

  ngOnInit() {
    if (!this.tooltip) {
      this.tooltip = this.title;
    }
    if (this.translateService) {
      this.translateService.onLanguageChanged.subscribe(() => {
        this.setDOMTitle();
      });
      this.setDOMTitle();
    }
  }

  setDOMTitle() {
    let tooltip = this.translateService.get(this.tooltip);
    this.elRef.nativeElement.setAttribute('title', tooltip);
  }

  configureI18n() {
    if (this.translateService) {
      this.translateService.use(this.locale);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-locale-side-menu-item',
  template: `
    <div class="fake-li mat-primary">
     <a class="mat-list-item-content" (click)="configureI18n()">
        <md-icon *ngIf="icon" class="o-side-menu-item-icon mat-24">{{ icon }}</md-icon>
        <div class="o-side-menu-item-title">{{ title | oTranslate }}</div>
      </a>
    </div>
  `,
  styles: [`
    o-locale-side-menu-item .mat-list-item-content{display:flex;justify-content:flex-start;align-items:center;height:auto;min-height:45px;padding:0px 10px}o-locale-side-menu-item .o-locale-side-menu-item-text{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;box-sizing:border-box;font-size:16px;height:48px;padding:0 16px}o-locale-side-menu-item .o-side-menu-item-icon{margin:0px 10px 0px 0px}o-locale-side-menu-item .o-side-menu-item-icon ~ .o-side-menu-item-title{padding-left:0px}o-locale-side-menu-item .o-side-menu-item-title{position:relative;top:1px;padding-left:33px}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_LOCALE_SIDE_MENU_ITEM
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OSideMenuComponent, decorators: [{ type: Inject, args: [forwardRef(() => OSideMenuComponent), ] }, ]},
{type: ElementRef, },
{type: Injector, },
];
}


export class OLocaleSideMenuItemModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OLocaleSideMenuItemComponent],
  imports: [OSharedModule, CommonModule, RouterModule, OSideMenuModule],
  exports: [OLocaleSideMenuItemComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
